var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contacts',{attrs:{"associatedcontacts":_vm.selectedContacts,"isloading":_vm.isLoading},on:{"contacts":function($event){return _vm.fetchContacts()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }